import http from '../api/axios';

export const getAnalyzeFollowerList = (params) => {
    return http.post('/api/index/analyzeFollower',params);
};
export const getRecommendNum = (params) => {
    return http.post('/api/index/recommendNum',params);
};
export const getScanFilerData = (params) => {
    return http.post('/api/index/scanFilerData',params);
};



// WEBPACK FOOTER //
// ./src/api/tool.js